<div class="component-container w-[70vw] sx:w-[70vw] xs:w-[90vw] xs:h-[100vh]">
  <div class="heading {{ loading ? 'hidden' : ''}}">
    Session {{ sessionId }} Details for {{ user?.participantName }}
  </div>
  <div class="user-details-container">
    <app-user-details
      [groupId]="groupId"
      [groupStatus]="groupStatus"
      [loading]="loading"
      [sessionCompleted]="sessionCompleted"
      [sessionDetails]="sessionDetails"
      [sessionId]="sessionId"
      [userList]="userList"
      [user]="user"
      class="user-details"
    />
  </div>
</div>
